var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-header-minicart" }, [
    _c(
      "a",
      {
        staticClass: "c-btn c-btn--cart has-size-40",
        class: { "is-active": _vm.isOpen },
        attrs: { href: "/nakupny-kosik", "data-quantity": _vm.count },
        on: { click: _vm.handleMinicartClick },
      },
      [
        _c("i", {
          staticClass: "ico ico-cart",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _vm.isEmpty
          ? _c("span", { staticClass: "is-text" }, [
              _vm._v(_vm._s(_vm.$t("Minicart.Trigger.title"))),
            ])
          : _c("span", { staticClass: "is-price" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.formatPrice(
                      _vm.pricesWithVat ? _vm.totalPrice : _vm.subtotalPrice
                    )
                  ) +
                  "\n            "
              ),
              _c("i", { staticClass: "ico ico-caret-down" }),
            ]),
        _vm._v(" "),
        !_vm.isEmpty
          ? _c(
              "div",
              {
                staticClass: "c-badge is-active",
                attrs: { "data-count": _vm.count },
              },
              [_vm._v(_vm._s(_vm.count))]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _vm.isOpen
      ? _c(
          "div",
          {
            class: {
              "c-minicart": true,
              "is-loading": _vm.isLoading,
            },
          },
          [
            _c(
              "div",
              { staticClass: "c-minicart__products-wrapper" },
              [
                _c("div", { staticClass: "c-minicart__header" }, [
                  _c("div", { staticClass: "is-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("Minicart.Header.title")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-text" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.pricesWithVat
                            ? _vm.$t("Minicart.Header.textWithVat")
                            : _vm.$t("Minicart.Header.textWithoutVat")
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isInitialized && !_vm.isEmpty
                    ? _c("div", { staticClass: "c-msg c-msg--success" }, [
                        _c("i", { staticClass: "ico ico-truck" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.freeShippingText) },
                        }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.isInitialized
                  ? [
                      !_vm.isEmpty
                        ? _c(
                            "div",
                            { staticClass: "c-minicart__products" },
                            _vm._l(_vm.items, function (item) {
                              return _c("MinicartItem", {
                                key: item.cart_id,
                                attrs: {
                                  item: item,
                                  isUpdatingQuantity:
                                    _vm.updatingQuantity[item.cart_id],
                                },
                                on: {
                                  remove: _vm.removeItem,
                                  spinningQuantity: _vm.spinningQuantity,
                                  updateQuantity: _vm.updateQuantity,
                                },
                              })
                            }),
                            1
                          )
                        : _c("div", { staticClass: "c-minicart__empty" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("Minicart.emptyText")) +
                                "\n                "
                            ),
                          ]),
                      _vm._v(" "),
                      _vm.showEstimate && _vm.isEstimateActive
                        ? _c("div", { staticClass: "c-estimate-info" }, [
                            _c(
                              "div",
                              { staticClass: "c-estimate-info__icon" },
                              [
                                _c("img", {
                                  staticClass:
                                    "c-img c-estimate-info__icon__image",
                                  attrs: {
                                    src: "/img/icons/low-price-black.svg",
                                    alt: _vm.$t("Minicart.estimate.imageAlt"),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "c-estimate-info__title" },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("Minicart.estimate.title")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "ico ico-fa-info-circle js-tippy",
                                  attrs: {
                                    "data-tippy-content": _vm.$t(
                                      "Minicart.estimate.tooltip"
                                    ),
                                    "data-tippy-z-index": "101",
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInitialized && !_vm.isEmpty
                  ? _c("div", { staticClass: "c-minicart__subtotal" }, [
                      _c("div", { staticClass: "c-minicart-subtotal" }, [
                        _c(
                          "div",
                          { staticClass: "c-minicart-subtotal__item" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "c-minicart-subtotal__key is-bigger",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.pricesWithVat
                                        ? _vm.$t("Minicart.priceWithVat")
                                        : _vm.$t("Minicart.priceWithoutVat")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "c-minicart-subtotal__value is-bigger",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatPrice(
                                    _vm.pricesWithVat
                                      ? _vm.totalPrice
                                      : _vm.subtotalPrice
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.savings > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "c-minicart-subtotal__item h-is-red",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "c-minicart-subtotal__key" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("Minicart.savings")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "c-minicart-subtotal__value",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formatPrice(_vm.savings)
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.showEstimate && _vm.isEstimateActive
                        ? _c(
                            "button",
                            {
                              staticClass: "c-btn c-btn--ghost has-size-45",
                              attrs: {
                                title: _vm.$t("Minicart.estimate.btnTitle"),
                              },
                              on: { click: _vm.submitEstimate },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("Minicart.estimate.btnTitle")) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "c-btn c-btn--cart has-size-45",
                          attrs: {
                            href: "/nakupny-kosik",
                            title: _vm.$t("Minicart.proceedToCheckout"),
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("Minicart.proceedToCheckout")) +
                              "\n                    "
                          ),
                          _c("i", {
                            staticClass:
                              "ico ico-caret-right-thick is-on-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }